module.exports = __webpack_public_path__ + "img/back2.53874d11.svg";